var LayerSelectorOverlay = function (data, opts) {};

module.exports = LayerSelectorOverlay;
